import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./context/authContext";
import { CheckToken } from "./tokencheck";

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useContext(AuthContext)
  const ex = CheckToken()

  if ( !ex ) {
    return < Navigate to="/login"/>
  }

  if (!user){
    return <Navigate to="/login" />;
  } 

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/login" />;
  }

  return children;
};
